<template>
  <div class="index">
    <el-scrollbar>
      <div class="task">
        <el-card header="文章待处理任务">
          <el-button class="task-btn">
            <div class="task-item">
              <i class="el-icon-finished"></i>
              <p>待审核： <b>0</b></p>
            </div>
          </el-button>          
        </el-card>
      </div>
      <div class="count">
        <el-card header="用户数量">
          <p class="count-info">0</p>
          <el-divider />
          <div class="count-info-down">
            <span>今日新增</span>
            <span>0</span>
          </div>
        </el-card>
        <el-card header="文章数量">
          <p class="count-info">0</p>
          <el-divider />
          <div class="count-info-down">
            <span>今日发布</span>
            <span>0</span>
          </div>
        </el-card>     
      </div>     
    </el-scrollbar>
  </div>

</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class OrderDetail extends Vue { 
  activated() {
    
  }  
}
</script>

<style lang="scss">
.index {
  height: calc(100vh - 180px);
}
.count {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 30px;
}
.ins {
  margin-top: 20px;
}
.ins-content {
  display: flex;
}

.count-info {
  font-size: 24px;
  font-weight: bold;
  line-height: 30px;
  margin: 0;
}

.count-info-down {
  display: flex;
  justify-content: space-between;
}

.task-item i {
  color: black;
  font-size: 30px;
}

.task-item p {
  color: black;
}
</style>
